module.exports = __webpack_public_path__ + "c_static/img/1-3电脑淘宝收藏夹.a13d0a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/4-回购特卖入口/1-3电脑淘宝收藏夹.jpg
// module id = 13fL
// module chunks = 33